import React from 'react';
import { isImage, isPDF } from '../../../utils/documents';
import PDFViewer from '../shipments/PDFViewer';

export function DocumentsPreview({
  files,
  placeholder = '',
  paginationContainer,
}) {
  return (
    <div>
      {files.map((file, index) => {
        let fileType = file.type;

        if (isPDF(fileType)) {
          return (
            <div key={index}>
              <PDFViewer
                file={file}
                paginationContainer={paginationContainer}
              />
            </div>
          );
        }

        if (isImage(fileType)) {
          return (
            <div key={index}>
              <img
                className="w-full h-auto"
                alt="Preview"
                src={file.preview ? file.preview : placeholder}
              />
            </div>
          );
        }

        return <div key={index}>{file.name || placeholder}</div>;
      })}
    </div>
  );
}
